<ng-template #projectedContent>
  <ng-content></ng-content>
</ng-template>

@if (routerLink !== undefined) {
  <a
    [routerLink]="routerLink"
    class="button"
    [class.size-s]="size === 's'"
    [class.size-m]="size === 'm'"
    [class.round-circle]="round === 'circle'"
    [class.variant-solid]="variant === 'solid'"
    [class.variant-solid-white]="variant === 'solid-white'"
    [class.variant-solid-accent]="variant === 'solid-accent'"
    [class.variant-outline-accent]="variant === 'outline-accent'"
    [class.variant-flat]="variant === 'flat'"
    [class.variant-ghost]="variant === 'ghost'"
    [ngClass]="class"
  >
    <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
  </a>
}
@else {

<button
  class="button"
  [class.size-s]="size === 's'"
  [class.size-m]="size === 'm'"
  [class.round-circle]="round === 'circle'"
  [class.variant-solid]="variant === 'solid'"
  [class.variant-solid-white]="variant === 'solid-white'"
  [class.variant-solid-accent]="variant === 'solid-accent'"
  [class.variant-outline-accent]="variant === 'outline-accent'"
  [class.variant-flat]="variant === 'flat'"
  [class.variant-ghost]="variant === 'ghost'"
  [class.disabled]="disabled"
  [disabled]="disabled"
  [ngClass]="class"
>
  <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
</button>
}
